import { z } from "zod";

import { zDate } from "@/lib/zod/show-fragments";
import { zLeagueRef } from "@/pages/sports/schemas/sports-fragments";
import type {
  ITeamCompetitionStats,
  ITeamSeasonStats,
  ITeamSplit,
} from "@/types/team-season-stats";

const zSplit: z.ZodType<ITeamSplit> = z
  .object({
    played: z.number().nullish(),
    won: z.number().nullish(),
    drawn: z.number().nullish(),
    lost: z.number().nullish(),
    goalsFor: z.number().nullish(),
    goalsAgainst: z.number().nullish(),
  })
  .passthrough();

const zCompetition: z.ZodType<ITeamCompetitionStats> = z
  .object({
    league: zLeagueRef.nullish(),
    leagueName: z.string().nullish(),
    total: zSplit.nullish(),
    home: zSplit.nullish(),
    away: zSplit.nullish(),
  })
  .passthrough();

/**
 * Read-only view schema for `GET /api/teams/{id}/season-stats` — the whole
 * TeamSeasonStatsDbDto: the team's current-season record per competition.
 */
export const teamSeasonStatsViewSchema: z.ZodType<ITeamSeasonStats> = z
  .object({
    season: z.string().nullish(),
    competitions: z.array(zCompetition).nullish(),
    updatedAt: zDate,
    updatedBy: z.string().nullish(),
  })
  .passthrough();
